import moment from "moment";
import React, { useState, useEffect } from "react";
import { NavLink as Link, withRouter } from "react-router-dom";
import Img from "../widgets/Img";
import { route } from "../global/route.global";
function CareerItem({ item }) {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className="card">
      <div className="card-header" id="headingOne">
        <h5 className="mb-0">
          <div
            className="btn"
            onClick={() => setIsOpen(!isOpen)}
            style={{ textAlign: "left", width: "100%" }}
          >
            <div className="d-flex justify-content-between">
              <span className="title">{item.job_title}</span>

              <span className="date">
                <span className="text-sm">Date posted: </span>{" "}
                {moment(item.created_at).format("MMMM D, YYYY")}
              </span>
            </div>
          </div>
        </h5>
      </div>
      <div
        id="collapseOne"
        className={`collapse ${isOpen ? "show" : ""}`}
        aria-labelledby="headingOne"
        data-parent="#accordionExample"
      >
        <div className="card-body">
          {item.attachments.length > 0 ? (
            <div className="d-flex flex-column container">
              <p className="">Attatchments: </p>
              {item.attachments.map((img, index) => {
                return (
                  <div
                    className="d-flex justify-content-between row mb-2"
                    key={index}
                  >
                    <span>
                      <a
                        href={`${route.domain}/storage/${img}`}
                        target="_blank"
                        className="col-lg-3"
                      >
                        {img.endsWith(".pdf") ? (
                          <i className="fa fa-file-pdf-o text-16"></i>
                        ) : (
                          <Img
                            src={`${route.domain}/storage/${img}`}
                            alt="img"
                            width="200"
                          />
                        )}
                      </a>
                    </span>
                  </div>
                );
              })}
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default withRouter(CareerItem);
